import React, { useEffect } from "react";
import { Select, SelectProps } from "@mantine/core";
import { USER_ROLES } from "@/config/userRoles";

const USER_ROLE_OPTIONS = [
  {
    value: USER_ROLES.CONTENT_MANAGER,
    label: "Conent Manager",
    disabled: false,
  },
  {
    value: USER_ROLES.SCHEDULE_MANAGER,
    label: "Schedule Manager",
    disabled: false,
  },
  {
    value: USER_ROLES.MANAGER_ROLE,
    label: "Manager",
    disabled: false,
  },
] as const;

// TODO: Load roles form DB

export interface UserRoleSelectorProps
  extends Omit<SelectProps, "data" | "value" | "onChange"> {
  /** Current status value (100 for enabled, 0 for disabled) */
  value: string | null | undefined;

  /** Callback when status changes */
  onChange: (value: string | null) => void;
}

export const UserRoleSelector: React.FC<UserRoleSelectorProps> = ({
  value,
  onChange,
  placeholder = "Select role",
  required,
  ...selectProps
}) => {
  // Prepare select data with optional descriptions
  const selectData = USER_ROLE_OPTIONS.map((option) => {
    let label: string = option.label;

    return {
      value: option.value,
      label,
      disabled: option.disabled,
    };
  });

  // Auto-select first display type if required and no value is set
  useEffect(() => {
    if (required && value == null && onChange) {
      const firstOption = USER_ROLE_OPTIONS[0];
      if (firstOption && !firstOption.disabled) {
        onChange(firstOption.value);
      }
    }
  }, [required, value, onChange]);

  // Handle change and convert back to number
  const handleChange = (stringValue: string | null) => {
    onChange(stringValue);
  };

  return (
    <Select
      {...selectProps}
      data={selectData}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      clearable={false}
      allowDeselect={false}
      required
      size="md"
    />
  );
};

export { USER_ROLE_OPTIONS };
